import { render, staticRenderFns } from "./SiteCategoryTypesSelect.vue?vue&type=template&id=cbc8eeb8&scoped=true&lang=pug"
import script from "./SiteCategoryTypesSelect.vue?vue&type=script&lang=js"
export * from "./SiteCategoryTypesSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbc8eeb8",
  null
  
)

export default component.exports